import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import fetch from 'unfetch';

const cache = new InMemoryCache();
const link = ({ uri, key, language, credentials = 'same-origin' }) =>
    new HttpLink({
        fetch,
        uri,
        credentials,
        headers: {
            'x-api-key': key,
            'x-app-language': language,
        },
        connectToDevTools: true,
    });

export default function createApolloClient(props) {
    return new ApolloClient({
        cache,
        link: link(props),
    });
}
